import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide11ClassSocieties.css';

const societies = [
  { id: 'abs', name: 'American Bureau of Shipping', logo: '/images/class-societies/abs.png', white: true },
  { id: 'bv', name: 'Bureau Veritas', logo: '/images/class-societies/bv.png', white: true, large: true },
  { id: 'ccs', name: 'China Classification Society', logo: '/images/class-societies/ccs.png', white: true },
  { id: 'crs', name: 'Croatian Register of Shipping', logo: '/images/class-societies/crs.svg' },
  { id: 'dnv', name: 'Det Norske Veritas', logo: '/images/class-societies/dnv.png' },
  { id: 'irclass', name: 'Indian Register of Shipping', logo: '/images/class-societies/irclass.png', large: true },
  { id: 'kr', name: 'Korean Register', logo: '/images/class-societies/kr.png' },
  { id: 'lr', name: "Lloyd's Register", logo: '/images/class-societies/lr.svg' },
  { id: 'classnk', name: 'Nippon Kaiji Kyokai', logo: '/images/class-societies/classnk.svg', white: true, large: true },
  { id: 'prs', name: 'Polish Register of Shipping', logo: '/images/class-societies/prs.png', white: true, large: true },
  { id: 'rina', name: 'Registro Italiano Navale', logo: '/images/class-societies/rina.svg' },
  { id: 'turkloydu', name: 'Turk Loydu', logo: '/images/class-societies/turkloydu.png', white: true, large: true },
];

function Slide11ClassSocieties() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 20 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-class-societies">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="class-bg">
        <div className="class-grid" />
        <div className="class-glow class-glow-left" />
        <div className="class-glow class-glow-right" />
        <div className="class-noise" />
      </div>

      <div className="class-content">
        <motion.div className="class-left" {...fadeUp(0.05)}>
          <h1 className="class-title">
            Classification
            <br />
            Society Approvals
          </h1>
          <p>
            Avatec Marine operates in compliance with international maritime regulations and holds approvals from major
            classification societies.
          </p>
          <p>
            The company and its technical personnel maintain approvals from IACS member societies.
          </p>
          <p>
            Avatec Marine holds ISO 9001:2015 certification issued by Bureau Veritas.
          </p>
          <p>
            These approvals demonstrate Avatec Marine&apos;s capability to perform certified inspections, surveys,
            installations, commissioning, and maintenance services in accordance with international maritime standards.
          </p>
          <p className="class-italic">
            Operating in accordance with international maritime standards.
          </p>

          <div className="class-tags">
            <span>International Compliance</span>
            <span>IACS Member Approvals</span>
            <span>Certified Operations</span>
          </div>
        </motion.div>

        <motion.div className="class-card" {...fadeUp(0.35)}>
          <div className="class-card-title">Authorized Class Societies</div>
          <div className="class-divider" />
          <div className="class-grid-cards">
            {societies.map((society) => (
              <div key={society.id} className="class-item">
                <img
                  className={`class-logo ${society.white ? 'class-logo--white' : ''} ${society.large ? 'class-logo--large' : ''}`}
                  src={society.logo}
                  alt={society.name}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Slide11ClassSocieties;
